import { ChangeDetectionStrategy, Component, input, ViewEncapsulation } from '@angular/core';
import { applySearchRule } from '../../../../@core/utils/search-input-helper';
import { DiscountGroupDocumentRelation, DiscountGroupDocumentRelationSearchInput, Operator } from "../../../../generated/generated-types";
import { BaseListWrapperComponent } from '../../../../shared/components/base-list-wrapper/base-list-wrapper.component';
import { NewBaseListComponent } from "../../../../shared/components/new-base-list-component/new-base-list-component";
import { DiscountGroupDocumentRelationService } from "../../services/discount-group-document-relation.service";

@Component({
  selector: 'app-discount-group-document-relation-widget',
  // templateUrl: './discount-group-document-relation-widget.component.html'
  //
  template: `<app-base-list-wrapper [baseListComponent]="this" />`,
  encapsulation: ViewEncapsulation.Emulated,
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    BaseListWrapperComponent,
  ]
})
export class DiscountGroupDocumentRelationWidgetComponent extends NewBaseListComponent<DiscountGroupDocumentRelation> {

  discountGroupId = input<string>();

  constructor(
    private discountGroupDocumentRelationService: DiscountGroupDocumentRelationService,
  ) {
    super("DiscountGroupDocumentRelation", discountGroupDocumentRelationService);

    this.addInDetail = false;
    this.noCopy = true;
    this.noBaseEdit = true;
    this.inlineEditMode = true;
  }

  override getSearchInputForQuery(): DiscountGroupDocumentRelationSearchInput {
    let si: DiscountGroupDocumentRelationSearchInput = super.getSearchInputForQuery();

    applySearchRule(si, {
      field: "discountGroupId",
      operator: Operator.equal,
      value: this.discountGroupId()
    });

    return si;
  }

  // protected override setColumnConfig(colConfig: ColumnConfigEx): void {
  //   let documentIdentifierCol: ColumnDefinitionEx = colConfig.columns.find(x => x.field === 'document.identifier' || (x.prop === "identifier" && x.entityType === 'Document'));
  //   if (documentIdentifierCol) {
  //     documentIdentifierCol.getEditComponent = () => DocumentChooserDropDownComponent;
  //     documentIdentifierCol.editComponentCreated = async (c: DocumentChooserDropDownComponent, rowData: any, _colDef: ColumnDefinitionEx) => {
  //       if (rowData?.document)
  //         c.setModel(rowData.document);
  //       else if (rowData?.documentId) {
  //         await c.loadModelFromId(rowData.documentId);
  //         this.cdRef.detectChanges();
  //       }

  //       c.valueChange.pipe(takeUntilDestroyed(this.destroyRef)).subscribe(async (x: Document) => {
  //         rowData.documentId = x?.id;
  //       });
  //     }
  //   }

  //   super.setColumnConfig(colConfig);
  // }

  override saveInCRUDService(rowData: DiscountGroupDocumentRelation): Promise<DiscountGroupDocumentRelation> {
    return super.saveInCRUDService({ ...rowData, discountGroupId: this.discountGroupId() });
  }

}
